package com.bookbrief.model

import kotlinx.serialization.Serializable

@Serializable
data class Book(
    val bookId: String? = null,
    val title: String,
    val author: String,
    val firstPublishedYear: Int? = null,
    val category: String = "",
    val coverUrl: String = "",
    val summary: String = ""
)
